import { useEffect, useRef } from "react";
import { getSocket } from "@/lib/socket";

// Richiama `callback` (con debounce) quando il backend segnala un cambiamento dati.
export function useLiveRefresh(callback) {
  const cb = useRef(callback);
  cb.current = callback;
  useEffect(() => {
    const s = getSocket();
    let timer;
    const handler = () => {
      clearTimeout(timer);
      timer = setTimeout(() => cb.current && cb.current(), 400);
    };
    s.on("data_changed", handler);
    return () => { s.off("data_changed", handler); clearTimeout(timer); };
  }, []);
}
